//#region Util Imports

import * as _ from 'underscore'

//#endregion

//#region Helper Imports

import { LocalizationHelper } from '../../helpers'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'

//#endregion


//#region Public Types

export const DATE_BOX_CONTROLS_SERVICE_NAME = 'DateBoxControlsService'
export const DATE_BOX_CONTROLS_SERVICE_PROVIDER_NAME = 'DateBoxControlsServiceProvider'

export interface GetDateBoxOptions {
    format?: string,
}

//#endregion


export class DateBoxControlsService {

    //#region Ctor

    constructor() { }

    //#endregion


    public getDateBoxOptions(options: GetDateBoxOptions): DevExpress.ui.dxDateBoxOptions {
        const dateValue: Date = new Date()
        let dateType: 'date' | 'datetime' | 'time' = 'date'
        let format = null

        if (options != null) {
            if (options.format != null) {
                format = options.format
            }
        }

        if (this.formatContainsTimePart(format)) {
            dateType = 'datetime'
        }

        if (dateType === 'date') {
            dateValue.setHours(0, 0, 0, 0)
        }

        return {
            displayFormat: format,
            type: dateType,
            value: dateValue,
            invalidDateMessage: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.InvalidDate),
            dateOutOfRangeMessage: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ValueIsOutOfRange),
        }
    }

    private formatContainsTimePart(format: string): boolean {
        if (format != null) {
            return new RegExp('(?:h|H|m|s|S)+').test(format)
        }

        return false
    }
}

export class DateBoxControlsServiceProvider implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [function () {
        return new DateBoxControlsService()
    }]

    //#endregion
} 